import React, { useRef, useState, useEffect } from "react";
import MDBox from "shared/ui/Box/MDBox";
import Icon from "@mui/material/Icon";
import PropTypes from "prop-types";
import { alpha } from "@mui/material/styles";

export default function ExerciseScrollArea({ children }) {
  const scrollRef = useRef(null);
  const [scrollTop, setScrollTop] = useState(0);
  const [showBottomFade, setShowBottomFade] = useState(true);

  const update = () => {
    const el = scrollRef.current;
    if (!el) return;

    setScrollTop(el.scrollTop);

    const atBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 10;
    setShowBottomFade(!atBottom);
  };

  useEffect(() => {
    const t = setTimeout(() => update(), 0);

    const el = scrollRef.current;
    if (!el) return;

    el.addEventListener("scroll", update);
    window.addEventListener("resize", update);

    return () => {
      clearTimeout(t);
      el.removeEventListener("scroll", update);
      window.removeEventListener("resize", update);
    };
  }, [children]); // 👈🔥 IMPORTANTE

  const scrollDown = () => (scrollRef.current.scrollTop += 180);
  const scrollUp = () => (scrollRef.current.scrollTop -= 180);

  return (
    <MDBox
      sx={{
        position: "relative",
        flexGrow: 1,
        height: "100%",
        minHeight: 0,
        overflow: "hidden",
      }}
    >
      {/* Flecha ARRIBA */}
      {scrollTop > 5 && (
        <MDBox
          onClick={scrollUp}
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            height: "38px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            zIndex: 3,
            background: (theme) =>
              `linear-gradient(to bottom, ${theme.palette.background.paper}, ${alpha(
                theme.palette.background.paper,
                0
              )})`,
          }}
        >
          <Icon sx={{ color: "text.secondary" }}>expand_less</Icon>
        </MDBox>
      )}

      <MDBox
        ref={scrollRef}
        sx={{
          height: "100%",
          overflowY: "auto",
          scrollbarWidth: "none",
          "&::-webkit-scrollbar": { display: "none" },
          display: "flex",
          flexDirection: "column",
          gap: "8px",
          scrollBehavior: "smooth",
          paddingRight: "0px",
        }}
      >
        {children}
      </MDBox>

      {/* Fade inferior + flecha */}
      {showBottomFade && (
        <>
          <MDBox
            sx={{
              position: "absolute",
              bottom: 0,
              left: 0,
              right: 0,
              height: "60px",
              pointerEvents: "none",
              background: (theme) =>
                `linear-gradient(to top, ${theme.palette.background.paper}, ${alpha(
                  theme.palette.background.paper,
                  0
                )})`,
            }}
          />

          <MDBox
            onClick={scrollDown}
            sx={{
              position: "absolute",
              bottom: 0,
              left: 0,
              right: 0,
              height: "38px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              zIndex: 10,
            }}
          >
            <Icon sx={{ color: "text.secondary" }}>expand_more</Icon>
          </MDBox>
        </>
      )}
    </MDBox>
  );
}

ExerciseScrollArea.propTypes = {
  children: PropTypes.node.isRequired,
};
